import { Outlet } from 'react-router-dom';
import { Box, Stack, Typography } from '@mui/material';
import ApartmentIcon from '@mui/icons-material/Apartment';
import { useTenant } from '../contexts/TenantContext';

/**
 * Layout-route guard for tenant-scoped views. When no customer is selected
 * the wrapped view is NOT rendered (so none of its tenant-scoped API
 * requests fire) and a "no customer selected" state is shown instead.
 *
 * The api layer additionally hard-blocks tenant-scoped requests without an
 * active customer (see core/services/api.ts) — this component is the UX,
 * that interceptor is the safety net.
 */
export function RequireTenant() {
  const { activeTenantId } = useTenant();

  if (activeTenantId === null) {
    return (
      <Box
        sx={{
          flex: 1,
          minHeight: '60vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Stack spacing={1.5} alignItems="center" sx={{ textAlign: 'center', maxWidth: 420 }}>
          <ApartmentIcon sx={{ fontSize: 48, color: 'text.disabled' }} />
          <Typography variant="h6">No customer selected</Typography>
          <Typography variant="body2" color="text.secondary">
            This page shows data for a specific customer. Select a customer from the
            &ldquo;Active customer&rdquo; dropdown in the sidebar to load it.
          </Typography>
        </Stack>
      </Box>
    );
  }

  return <Outlet />;
}
